import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { productSearchAPI } from 'src/api/ProductApi';

const ProductDropDown = ({
    value, name, productCategory, disabled, onChange
}) => (
    <FormikSearchDropdown
        onChange={onChange}
        name={name}
        placeholder="Select Product"
        displayKeyPath={[
            'productName',
            // 'meta.cubicCapacity'
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'productName',
            // 'meta.cubicCapacity'
        ]}
        api={productSearchAPI}
        apiCallAddonData={{
            pageLength: '',
        }}
        value={value}
        whereConditions={{
            category: productCategory,
            active: true,
        }}
        disabled={!productCategory || disabled}
    />
);

ProductDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    productCategory: PropTypes.string,
    disabled: PropTypes.bool,
    onchange: PropTypes.any,
};

ProductDropDown.defaultProps = {
    value: '',
    productCategory: '',
    disabled: false,
    onchange: onchange
};

export default ProductDropDown;
